import { useTranslationNameSpace, NAME_SPACES } from 'i18n/hooks';
import { GetInTouchSection } from 'modules/sections/components';
import { MobileSlider } from 'modules/sections/components/Slider/Slider.mobile';
import {
  FlexColumn,
  TEXT_TYPES,
  COLORS,
  TEXT_WEIGHTS,
  FlexRow,
  TEXT_SIZES,
  FlotableElement,
  Square,
  Text,
} from 'modules/ui/components';
import { Animatable, ANIMATIONS_TYPES } from 'modules/ui/components/Animatable';
import { PageTitle } from 'modules/ui/components/PageTitle';
import { subCards, points, sliderMobileStyles } from './utils';

export const MobileDataAndAnalytics = () => {
  const { t } = useTranslationNameSpace(NAME_SPACES.PAGES);

  return (
    <FlexColumn w="100%" h="100%">
      <PageTitle title={t('dataAndAnalytics.title')} />
      <FlexColumn
        w="100%"
        alignItems="center"
        position="relative"
        bgSize="cover"
        bg="url(./assets/backgrounds/background-4.png)"
      >
        <FlexColumn w="80%" alignItems="center">
          <FlexColumn w="100%" alignItems="center">
            <Text
              m="35px 0 26px 0"
              size="36px"
              type={TEXT_TYPES.title}
              color={COLORS.lightBlue}
              weight={TEXT_WEIGHTS.bolder}
              letterSpacing="1.4px"
              lineHeight="35px"
              textAlign="center"
            >
              {t('dataAndAnalytics.cards.0.title')}
            </Text>
            <Text
              w="100%"
              size="28px"
              type={TEXT_TYPES.text}
              color={COLORS.white}
              weight={TEXT_WEIGHTS.tiny}
              textAlign="center"
              whiteSpace="pre-wrap"
              lineHeight="40px"
            >
              {t('dataAndAnalytics.cards.0.text')}
            </Text>
          </FlexColumn>
          <FlexRow m="40px 0 80px 0">
            <img
              src="./assets/data&analytics/card-0.png"
              alt="story"
              width={141}
              height={131}
            />
          </FlexRow>
          <Animatable animationType={ANIMATIONS_TYPES.appendBottom}>
            <FlexColumn w="100%" alignItems="center">
              <Text
                m="70px 0 26px 0"
                size="30px"
                type={TEXT_TYPES.title}
                color={COLORS.lightBlue}
                weight={TEXT_WEIGHTS.bolder}
                letterSpacing="1.2px"
                lineHeight="32px"
                textAlign="center"
              >
                {t('dataAndAnalytics.cards.1.title')}
              </Text>
              <Text
                w="100%"
                size="25px"
                type={TEXT_TYPES.text}
                color={COLORS.white}
                weight={TEXT_WEIGHTS.tiny}
                textAlign="center"
                whiteSpace="pre-wrap"
                letterSpacing="0.88px"
                lineHeight="30px"
              >
                {t('dataAndAnalytics.cards.1.text')}
              </Text>
            </FlexColumn>
          </Animatable>
          <FlexColumn
            m="35px 0 0 0"
            w="100%"
            justifyContent="center"
            flexWrap="wrap"
          >
            <MobileSlider
              styles={sliderMobileStyles}
              slides={subCards.map((_, i) => (
                <FlexColumn w="100%" alignItems="center" m="60px auto">
                  <FlexColumn w="100%" alignItems="center">
                    <img
                      src={`./assets/data&analytics/subCard-${i}.png`}
                      alt="sub-card"
                      className="img"
                    />
                    <Text
                      m="30px 0 10px 0"
                      size="30px"
                      letterSpacing="1.4px"
                      type={TEXT_TYPES.title}
                      color={COLORS.lightBlue}
                      weight={TEXT_WEIGHTS.bolder}
                      whiteSpace="pre-wrap"
                      textAlign="center"
                    >
                      {t(`dataAndAnalytics.subCards.${i}.title`)}
                    </Text>
                    <Text
                      w="100%"
                      size={TEXT_SIZES.s}
                      type={TEXT_TYPES.text}
                      color={COLORS.white}
                      weight={TEXT_WEIGHTS.tiny}
                      textAlign="center"
                      letterSpacing="0.56px"
                      lineHeight="30px"
                      whiteSpace="pre-wrap"
                    >
                      {t(`dataAndAnalytics.subCards.${i}.text`)}
                    </Text>
                  </FlexColumn>
                </FlexColumn>
              ))}
            />
          </FlexColumn>
          <FlexColumn m="40px 0" w="100%" alignItems="center">
            <img
              src="./assets/data&analytics/card-1.png"
              alt="story"
              width={144}
              height={170}
            />
            <FlexColumn w="80%">
              <Animatable animationType={ANIMATIONS_TYPES.appendBottom}>
                <Text
                  m="20px 0"
                  size="30px"
                  letterSpacing="1.2px"
                  type={TEXT_TYPES.title}
                  color={COLORS.lightBlue}
                  weight={TEXT_WEIGHTS.bolder}
                  whiteSpace="pre-wrap"
                  textAlign="center"
                  lineHeight="30px"
                >
                  {t(`dataAndAnalytics.cards.2.title`)}
                </Text>
                <Text
                  w="100%"
                  size={TEXT_SIZES.s}
                  type={TEXT_TYPES.text}
                  color={COLORS.white}
                  weight={TEXT_WEIGHTS.tiny}
                  letterSpacing="0.56px"
                  lineHeight="23px"
                  whiteSpace="pre-wrap"
                  textAlign="center"
                >
                  {t(`dataAndAnalytics.cards.2.text`)}
                </Text>
              </Animatable>
            </FlexColumn>
          </FlexColumn>
          <FlexColumn w="100%" alignItems="center">
            <Animatable animationType={ANIMATIONS_TYPES.appendBottom}>
              <FlexColumn w="100%" alignItems="center">
                <Text
                  m="20px 0"
                  size="30px"
                  letterSpacing="1.4px"
                  type={TEXT_TYPES.title}
                  color={COLORS.lightBlue}
                  weight={TEXT_WEIGHTS.bolder}
                  whiteSpace="pre-wrap"
                  textAlign="center"
                >
                  {t(`dataAndAnalytics.cards.3.title`)}
                </Text>
                <Text
                  w="100%"
                  size={TEXT_SIZES.s}
                  type={TEXT_TYPES.text}
                  color={COLORS.white}
                  weight={TEXT_WEIGHTS.tiny}
                  letterSpacing="0.56px"
                  lineHeight="25px"
                  whiteSpace="pre-wrap"
                  textAlign="center"
                >
                  {t(`dataAndAnalytics.cards.3.text`)}
                </Text>
              </FlexColumn>
            </Animatable>
          </FlexColumn>
        </FlexColumn>
        <FlexColumn
          w="100%"
          alignItems="center"
          justifyContent="center"
          bg={'rgba(79, 255, 255, 0.001)'}
        >
          <FlexColumn w="80%" m="70px 0" alignItems="center">
            <img
              src="./assets/data&analytics/card-2.png"
              alt="card-2"
              width={152}
              height={161}
            />
            <FlexColumn m="50px 0 0 0">
              {points.map((_, i) => (
                <FlexRow w="100%" h="auto" alignItems="center" gap="12px">
                  <img src="./assets/utils/check-sign.png" alt="check" />
                  <Text
                    color={COLORS.white}
                    weight={TEXT_WEIGHTS.tiny}
                    size={TEXT_SIZES.s}
                    lineHeight="37px"
                    letterSpacing="0.56px"
                  >
                    {t(`dataAndAnalytics.points.${i}`)}
                  </Text>
                </FlexRow>
              ))}
            </FlexColumn>
          </FlexColumn>
        </FlexColumn>
        <GetInTouchSection title={t(`tv.contactSection.title`) as string} />
        <FlotableElement left="87%" top="15%">
          <Square zIndex="1" size="30vw" />
        </FlotableElement>
      </FlexColumn>
    </FlexColumn>
  );
};
